/**
 * Ilustração (desenhada, SEM dados reais) que mostra ONDE fica o código de
 * desbloqueio no comprovante: os 6 dígitos logo abaixo do QR Code.
 * O "nome", "data" e demais textos do comprovante viram barras cinza
 * (placeholders) — nenhuma identificação real. Uma seta laranja aponta para o
 * código em destaque. Decorativa, com `role='img'` + `aria-label` descritivo.
 */
export const IlustracaoCodigoDesbloqueio = () => (
  <figure className='ilustracao-codigo'>
    <svg
      className='ilustracao-codigo__svg'
      viewBox='0 0 260 200'
      role='img'
      aria-label='Exemplo de comprovante: o código de desbloqueio são os seis dígitos logo abaixo do QR Code'
    >
      {/* comprovante (papel) */}
      <rect
        x='26'
        y='10'
        width='150'
        height='180'
        rx='14'
        fill='#fff'
        stroke='rgba(55,30,86,0.18)'
        strokeWidth='2'
      />

      {/* QR Code abstrato (não é um QR real) */}
      <g fill='#371E56'>
        <rect
          x='60'
          y='24'
          width='82'
          height='82'
          rx='6'
          fill='none'
          stroke='rgba(55,30,86,0.15)'
          strokeWidth='2'
        />
        {/* finder patterns nos 3 cantos */}
        <rect x='68' y='32' width='20' height='20' rx='3' />
        <rect x='72' y='36' width='12' height='12' rx='2' fill='#fff' />
        <rect x='76' y='40' width='4' height='4' />
        <rect x='114' y='32' width='20' height='20' rx='3' />
        <rect x='118' y='36' width='12' height='12' rx='2' fill='#fff' />
        <rect x='122' y='40' width='4' height='4' />
        <rect x='68' y='78' width='20' height='20' rx='3' />
        <rect x='72' y='82' width='12' height='12' rx='2' fill='#fff' />
        <rect x='76' y='86' width='4' height='4' />
        {/* módulos soltos */}
        <rect x='98' y='34' width='5' height='5' />
        <rect x='98' y='44' width='5' height='5' />
        <rect x='106' y='62' width='5' height='5' />
        <rect x='96' y='70' width='5' height='5' />
        <rect x='116' y='72' width='5' height='5' />
        <rect x='126' y='64' width='5' height='5' />
        <rect x='98' y='88' width='5' height='5' />
        <rect x='110' y='90' width='5' height='5' />
        <rect x='124' y='84' width='5' height='5' />
      </g>

      {/* código em destaque (placeholder genérico) */}
      <rect x='70' y='114' width='62' height='22' rx='6' fill='rgba(255,130,18,0.16)' />
      <text
        x='101'
        y='130'
        textAnchor='middle'
        fontSize='15'
        fontWeight='700'
        letterSpacing='2'
        fill='#371E56'
      >
        599773
      </text>

      {/* "textos" do comprovante como barras cinza (sem identificação) */}
      <rect x='58' y='148' width='86' height='6' rx='3' fill='rgba(55,30,86,0.12)' />
      <rect x='72' y='160' width='58' height='6' rx='3' fill='rgba(55,30,86,0.12)' />
      <rect x='78' y='172' width='46' height='5' rx='2.5' fill='rgba(55,30,86,0.10)' />

      {/* seta apontando para o código */}
      <path
        d='M236 98 C 200 108, 172 118, 138 125'
        fill='none'
        stroke='#FF8212'
        strokeWidth='3.5'
        strokeLinecap='round'
      />
      <path d='M138 125 l 15 -2 l -7 -8 z' fill='#FF8212' />
      <text x='250' y='90' textAnchor='end' fontSize='11' fontWeight='700' fill='#FF8212'>
        Código de
      </text>
      <text x='250' y='103' textAnchor='end' fontSize='11' fontWeight='700' fill='#FF8212'>
        desbloqueio
      </text>
    </svg>
  </figure>
)
